import tcglandSidebar1 from '@/assets/ads/tcg.land/160x600/1.png'
import tcglandSidebar2 from '@/assets/ads/tcg.land/160x600/2.png'
import tcglandSidebar3 from '@/assets/ads/tcg.land/160x600/3.png'
import tcglandMobile1 from '@/assets/ads/tcg.land/320x50/1.png'
import tcglandMobile2 from '@/assets/ads/tcg.land/320x50/2.png'
import tcglandMobile3 from '@/assets/ads/tcg.land/320x50/3.png'
import tcglandMobile4 from '@/assets/ads/tcg.land/320x50/4.png'
import tcglandDesktop1 from '@/assets/ads/tcg.land/728x90/1.png'
import tcglandDesktop2 from '@/assets/ads/tcg.land/728x90/2.png'
import tcglandDesktop3 from '@/assets/ads/tcg.land/728x90/3.png'
import tcglandDesktop4 from '@/assets/ads/tcg.land/728x90/4.png'

const getRandomAd = (key: string) => {
  const images =
    key === 'tcg.land/sidebar'
      ? [tcglandSidebar1, tcglandSidebar2, tcglandSidebar3]
      : key === 'tcg.land/mobile'
        ? [tcglandMobile1, tcglandMobile2, tcglandMobile3, tcglandMobile4]
        : [tcglandDesktop1, tcglandDesktop2, tcglandDesktop3, tcglandDesktop4]
  const randomIndex = Math.floor(Math.random() * images.length)
  return images[randomIndex]
}

export default getRandomAd
